import { has } from 'lodash';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { $ModalType, $Modals, $ModalTypeObj } from './types';

const initialState = {
  ...(Object.keys($Modals).reduce((sum, item) => {
    return {
      ...sum,
      [item]: {
        status: false,
      },
    };
  }, {}) as unknown as $ModalTypeObj),
};

const modal = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<$ModalType>) => {
      const { status, key, ...rest } = action.payload;
      const _status = has(action.payload, 'status') ? status : !state?.[key]?.status;

      return {
        ...state,
        [key]: {
          status: _status,
          ...(_status ? rest : {}),
        },
      };
    },
    resetModal: () => initialState,
  },
});

export default modal;
